module.exports = "<bo-loader></bo-loader>\n<bo-toast></bo-toast>\n<router-outlet></router-outlet>\n"